var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgChevronDownNarrow = function SvgChevronDownNarrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 17 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1 1.25 7.5 7.5 7.5-7.5",
    stroke: "#0058AA",
    strokeWidth: 2
  })));
};

export { SvgChevronDownNarrow as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTEiIHZpZXdCb3g9IjAgMCAxNyAxMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEgMS4yNUw4LjUgOC43NUwxNiAxLjI1IiBzdHJva2U9IiMwMDU4QUEiIHN0cm9rZS13aWR0aD0iMiIvPgo8L3N2Zz4K";